<div class="view-container">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Your clients</label>
          <button *ngIf="admin || (companyAdmin && !clients)"
            mat-flat-button type="button"
            color="accent"
            (click)="onAddClient()"
            matTooltip="Create New Client">
            <mat-icon>key</mat-icon> Create New Client
          </button>
        </div>
        <mat *ngFor="let item of clients">
          <mat-card class="contrast" [class.banner-success]="item.enabled" [class.banner-error]="!item.enabled" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
            <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
              <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
                <strong [ngClass.lt-sm]="{'card-title': true}">{{ item?.clientId }}</strong>
              </div>
              <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                <div [fxFlex]="admin || companyAdmin ? 70 : 100" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                  <p class="lhm-10px-spacing"><small>scopes</small></p>
                  <div>&nbsp;{{ displayScopes(item?.allowedScopes) }}</div>
                  <div fxHide.lt-sm class="m-l-10 m-r-10">|</div>
                  <p class="lhm-10px-spacing"><small>created</small></p>
                  <div>&nbsp;{{ item?.created | date : 'short' }}</div>
                </div>
                <div *ngIf="admin || companyAdmin" fxFlex="30" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
                  <button *ngIf="admin || companyAdmin" mat-mini-fab color="primary"
                    aria-label="Generate a New ApiKey"
                    matTooltip="Generate a New ApiKey"
                    (click)="generateNewApiKey(item)"
                    [class.button-spinner]="loading"
                    [disabled]="">
                    <mat-icon>key</mat-icon>
                  </button>
                  <button *ngIf="admin" mat-mini-fab [color]="item.enabled ? 'basic' : 'accent'"
                    [aria-label]="item.enabled ? 'Disable Api Client' : 'Disable Api Client'"
                    [matTooltip]="item.enabled ? 'Disable Api Client' : 'Disable Api Client'"
                    (click)="toggleClientEnabled(item)"
                    [class.button-spinner]="loading"
                    [disabled]="">
                    <mat-icon>{{ (item.enabled ? 'toggle_off' : 'toggle_on') }}</mat-icon>
                  </button>
                  <button *ngIf="admin" mat-mini-fab color="warn"
                    aria-label="Delete Api Client"
                    matTooltip="Delete Api Client"
                    (click)="deleteClient(item)"
                    [class.button-spinner]="loading"
                    [disabled]="">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat>
      </mat-card-content>
    </mat-card>
  </div>
